import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { DonationFlowPaymentOption } from "@every.org/common/src/entity/types";

import { CloudinaryImg } from "src/components/CloudinaryImg";
import {
  AutocompleteSection,
  BrowseDropdownContainer,
  SearchTextInput,
} from "src/components/SearchTextInput";
import { InputBox } from "src/components/TextInput";
import { SectionAnchor } from "src/pages/Legal/TermsOfService";
import { MAX_TEXT_INPUT_WIDTH_VAR } from "src/theme/GlobalStyle/inputStyles";
import { spacing, verticalStackCss } from "src/theme/spacing";

const BG_LEFT_CLOUDINARY_ID = "search_section_bg_left_zdlmv8";
const BG_RIGHT_CLOUDINARY_ID = "search_section_bg_right_q2rj2p";
const BG_LEFT_HEIGHT = 185;
const BG_LEFT_WIDTH = 150;
const BG_RIGHT_HEIGHT = 205;
const BG_RIGHT_WIDTH = 125;

const TextInputContainer = styled.div`
  height: 500px;
  display: flex;
  width: 100%;
  justify-content: center;
  padding: 0 ${spacing.s};
  max-width: var(${MAX_TEXT_INPUT_WIDTH_VAR});
  position: relative;
`;

const StyledSearchTextInput = styled(SearchTextInput)`
  z-index: 2;
  width: 100%;
  ${InputBox}, ${BrowseDropdownContainer} {
    box-shadow: 0px 8px 32px -16px rgba(46, 52, 52, 0.2);
  }
  ${BrowseDropdownContainer} {
    // section height - search input height - spacing*
    // * - spacing for gap between the bottom of the dropdown
    // and the bottom of the section
    max-height: calc(500px - 60px - ${spacing.m});
  }
`;

const escapeOverlayCss = css`
  background-color: transparent;
  pointer-events: none;
`;

const StyledSection = styled.section`
  ${verticalStackCss.m};
  overflow: hidden;
  align-items: center;
  background: linear-gradient(
      180deg,
      rgba(0, 163, 127, 0) 0%,
      rgba(0, 163, 127, 0.05) 100%
    ),
    #ffffff;
  position: relative;
`;

export const SearchSection: React.FCC = () => (
  <StyledSection>
    <SectionAnchor id="search" />
    <h3 css={{ padding: `0 ${spacing.m}` }}>
      Search for your favorite nonprofit to donate crypto
    </h3>
    <TextInputContainer>
      <StyledSearchTextInput
        aria-label="Search for crypto"
        data-tname="search"
        alwaysOpen
        autoFocused={false}
        disableScrollLock
        escapeOverlayCss={escapeOverlayCss}
        autocompleteSection={[
          AutocompleteSection.NONPROFITS,
          AutocompleteSection.FUNDS,
        ]}
        donateMethod={DonationFlowPaymentOption.CRYPTO}
      />
      <div
        css={css`
          position: absolute;
          right: calc(100% - ${spacing.l});
          bottom: 25%;
          z-index: 1;
          height: ${BG_LEFT_HEIGHT}px;
          width: ${BG_LEFT_WIDTH}px;
        `}
      >
        <CloudinaryImg
          cloudinaryId={BG_LEFT_CLOUDINARY_ID}
          dimensions={{ height: BG_LEFT_HEIGHT, width: BG_LEFT_WIDTH }}
          alt="Crypto logos"
        />
      </div>
      <div
        css={css`
          position: absolute;
          left: calc(100% - ${spacing.l});
          top: 10%;
          z-index: 1;
          height: ${BG_RIGHT_HEIGHT}px;
          width: ${BG_RIGHT_WIDTH}px;
        `}
      >
        <CloudinaryImg
          cloudinaryId={BG_RIGHT_CLOUDINARY_ID}
          dimensions={{ height: BG_RIGHT_HEIGHT, width: BG_RIGHT_WIDTH }}
          alt="Crypto logos"
        />
      </div>
    </TextInputContainer>
  </StyledSection>
);
